import React from "react";
import { useEffect, useState } from "react";
import { PosttransfferPayment, getBankList } from "../../util/APIUtils";
import BankAccListBody from "./BankAccListBody";
import { LoadingOverlay } from "../../util/Helpers";

export default function BankAccList() {
  const [values, setValues] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });
  const [trans, setTrans] = useState([]);
  const [block, setBlock] = useState(false);
  const [transferPayment, setTransferPayment] = useState({
    toBank: "0",
  });
  const [modal, setModal] = useState(false);

  useEffect(() => {
    loadReqData();
  }, []);

  const loadReqData = () => {
    setBlock(true);
    getBankList(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  // model related code
  const updateTransfer = () => {
    if (!validate(transferPayment)) {
      return false;
    }
    setBlock(true);
    PosttransfferPayment(transferPayment).then((response) => {
      setTrans(response);
      setBlock(false);
      cancel();
    });
  };

  const validate = (transferPayment) => {
    if (Object.keys(transferPayment).length != 5) {
      document.getElementById("transError").textContent =
        "Fill all Required Fileds";
      return false;
    } else {
      document.getElementById("transError").textContent = "";
    }
    return true;
  };
  const onChangeTransfer = ({ target }) => {
    const { name, value } = target;
    setTransferPayment((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };

  const fromBank = (framBank) => {
    let name = "frmBank";
    setTransferPayment((previousState) => ({
      ...previousState,
      [name]: framBank,
    }));
  };

  const cancel = () => {
    setTransferPayment({
      toBank: "0",
    });
    toggle();
  };

  const toggle = () => setModal(!modal);

  return (
    <div className="animated fadeIn">
      {block && <LoadingOverlay />}
      <BankAccListBody
        data={trans}
        transferPayment={transferPayment}
        onChangeTransfer={onChangeTransfer}
        cancel={cancel}
        updateTransfer={updateTransfer}
        toggle={toggle}
        modal={modal}
        fromBank={fromBank}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/BankAccList.js